
import { Component, Vue } from "vue-property-decorator";
import PaymentCount from "./components/payment-count.vue";
import SchoolPayments from "./components/school-payments.vue";
import schoolAnalysis from "@/views/educationalIdentity/allAnalysis/index.vue"
import { UserModule } from "@/store/modules/user";
import Util from "@/lib/util";
@Component({
  name: "Dashboard",
  components: {
    PaymentCount,
    SchoolPayments,
    schoolAnalysis
  },
})
export default class extends Vue {
  isEducation = UserModule.user.isEdcationUser

}
